import { Image, Typography } from "antd";
import Logo from "assets/images/logo.svg";

const { Title } = Typography;

export default function BlockRequest() {
  return (
    <>
      <div className="block-request-wrapper">
        <div className="br-wrap">
          <div className="content-wrap">
            <Image preview={false} className="logo" src={Logo} />
            <Title level={4}>Invitation Blocked</Title>
            <p>
              You have blocked Abdul Aziz's invitation, and you will not receive
              any more invitations from him.
            </p>
          </div>
          <div className="footer">
            ResolveIT, LLC 2010 N Church Street #33368, Dealware United States
          </div>
        </div>
      </div>
    </>
  );
}
